import { DiscountCode } from '@/util/types/serverTypeCollection/discounts';

/**
 * Short human label for a discount code's value, e.g. `20% off` or `$50 off`.
 * Shared by every surface that shows an applied code so the wording matches.
 */
export function formatDiscountLabel(
  discountCode: Pick<DiscountCode, 'discountType' | 'discountValue'>
): string {
  return discountCode.discountType === 'percent'
    ? `${discountCode.discountValue}% off`
    : `$${discountCode.discountValue} off`;
}
